import { render, staticRenderFns } from "./loved.vue?vue&type=template&id=2a052a01&scoped=true&"
import script from "./loved.vue?vue&type=script&lang=js&"
export * from "./loved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a052a01",
  null
  
)

export default component.exports